import { render, staticRenderFns } from "./EditScopeSection.vue?vue&type=template&id=127bdaea&"
import script from "./EditScopeSection.vue?vue&type=script&lang=js&"
export * from "./EditScopeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports